export * from './mfa';
export * from './member';
export * from './organization';
export * from './sso';
import { useStytchTotpCreate, useStytchTotpAuthenticate, useStytchSmsOtpSend, useStytchSmsOtpAuthenticate, } from './mfa';
import { useStytchDeleteMfaPhoneNumber, useStytchDeleteMfaTotp, useStytchUpdateMember, useStytchUpdateSelf, } from './member';
import { useStytchUpdateOrganization } from './organization';
import { useStytchAuthenticateSSO, useStytchGetSSOConnections, useStytchDiscoverSSOConnections, useStytchDeleteSSOConnection, useStytchStartSSOFlow, useStytchCreateOIDCConnection, useStytchCreateExternalConnection, useStytchUpdateExternalConnection, useStytchUpdateOIDCConnection, useStytchCreateSAMLConnection, useStytchUpdateSAMLConnection, } from './sso';
// Export the hook functions directly instead of calling them
export function getStytchHooks() {
    return {
        createTotp: useStytchTotpCreate,
        authenticateTotp: useStytchTotpAuthenticate,
        sendSmsOtp: useStytchSmsOtpSend,
        authenticateSmsOtp: useStytchSmsOtpAuthenticate,
        deleteMfaPhoneNumber: useStytchDeleteMfaPhoneNumber,
        deleteMfaTotp: useStytchDeleteMfaTotp,
        updateMember: useStytchUpdateMember,
        updateSelf: useStytchUpdateSelf,
        updateOrganization: useStytchUpdateOrganization,
        startSSOFlow: useStytchStartSSOFlow,
        authenticateSSO: useStytchAuthenticateSSO,
        getSSOConnections: useStytchGetSSOConnections,
        discoverSSOConnections: useStytchDiscoverSSOConnections,
        deleteSSOConnection: useStytchDeleteSSOConnection,
        createOIDCConnection: useStytchCreateOIDCConnection,
        createExternalConnection: useStytchCreateExternalConnection,
        updateExternalConnection: useStytchUpdateExternalConnection,
        updateOIDCConnection: useStytchUpdateOIDCConnection,
        createSAMLConnection: useStytchCreateSAMLConnection,
        updateSAMLConnection: useStytchUpdateSAMLConnection,
    };
}
